import React from 'react';
import SEO from '../common/SEO';
import Hero from '../components/Hero';
import CoreBenefits from '../components/CoreBenefits';

const Home = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LightWell",
    "url": "https://www.lightwell.cz",
    "logo": "https://www.lightwell.cz/media/logo-lightwell.webp",
    "telephone": "+420 777 016 374",
    "email": "info@lightwell.cz",
    "address": { "@type": "PostalAddress", "addressCountry": "CZ" }
  };

  return (
    <>
      <SEO title="LightWell – Profesionální LED systémy pro světelnou reklamu" description="Specialista na LEDBAR GRID a LED panely pro reklamu. Vysoký výkon, pětiletá záruka a revoluční rychlost instalace pro výrobce reklamy v ČR." path="/" schema={schema} />
      <div className="pt-0">
        <Hero />
        <section className="py-20 bg-gray-50"><div className="max-w-7xl mx-auto px-4 text-center"><h1 className="text-4xl md:text-6xl font-bold italic tracking-tighter uppercase mb-8 text-gray-900">Specialista na LED reklamu</h1><p className="text-xl text-gray-600 max-w-3xl mx-auto">Dodáváme inovativní LEDBAR systémy, které mění způsob, jakým se podsvěcují světelné boxy a reklamní plochy.</p></div></section>
        <CoreBenefits />
      </div>
    </>
  );
};

export default Home;